import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { ImageWithFallback } from '../components/media/ImageWithFallback';
import { useNavigate } from 'react-router-dom';

function Updates() {
    const navigate = useNavigate();
    return (
        <div className="about-page">
            {/* Page Header */}
            <section className="page-header">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-7">
                            <h1 className="page-title animate-slide-up">News & Updates</h1>
                            <p className="page-subtitle animate-slide-up delay-1">
                                News & Updates shares the latest updates from HSC Foundation, including calls for applications, job and volunteer opportunities, and new initiatives.
                            </p>
                        </div>
                        <div className="col-lg-5">
                            <div className="header-graphic animate-fade-in delay-2">
                                <Icon icon="material-symbols:notifications-active" className="header-icon" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="story-section">
                <div className="container">
                    <div className="row align-items-start">
                        <div className="col-lg-9 mb-4 mb-lg-0">
                            <div className="process-timeline">
                                <div className="process-step" onClick={() => navigate('/announcements/1')}>
                                    <div className="step-content">
                                        <h4>Call for Applications (RGYTIA)</h4>
                                        <p>Route Tracers Global Services Ltd, invites applications from eligible members of the Young Surveyors Network (YSN), Nigeria for the Route Tracers YSN Geospatial Innovation Award (RTYGIA).</p>
                                        <span className="step-date">Jan 1, 2026</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Updates;
